<div
  class="flex max-h-96 w-80 flex-col overflow-hidden rounded-xl border bg-white shadow-xl">
  <div
    class="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3">
    <span class="text-sm font-bold uppercase text-neutral-30">
      {{ data.date | date: 'fullDate' }}
    </span>
  </div>

  <div class="space-y-4 overflow-y-auto p-4">
    @if (data.holidays.length > 0) {
      <div>
        <span class="day-type-title">Festivos</span>
        @for (holiday of data.holidays; track holiday.holidayId) {
          <div
            class="mb-2 flex flex-col rounded-lg p-2 last:mb-0"
            [ngClass]="getHolidayColorClasses(holiday.color)">
            <div class="flex items-center gap-2">
              <mat-icon class="qaroni-mat-icon-16">celebration</mat-icon>
              <span class="text-sm font-bold">{{ holiday.name }}</span>
            </div>
            <span
              class="mt-1 w-fit rounded border border-current px-1 text-xs font-semibold opacity-80">
              {{ holiday.type | holidayType }}
            </span>
          </div>
        }
      </div>
    }

    @if (data.absences.length > 0) {
      <div>
        <span class="day-type-title">Ausencias</span>
        <div class="flex flex-col gap-1">
          @for (abs of data.absences; track abs.employeeAbsenceId) {
            <div
              class="flex flex-col gap-1 rounded-lg p-3 last:mb-0"
              [ngClass]="getAbsenceColorClasses(abs?.absence?.color)">
              <div class="flex items-center gap-2">
                <mat-icon class="qaroni-mat-icon-16">person_off</mat-icon>
                <span class="flex-1 text-sm font-bold">
                  {{ abs?.absence?.type ?? abs.absence.name }}
                </span>
              </div>
              <span
                class="w-fit rounded border border-current px-2 py-0.5 text-[10px] font-semibold opacity-80">
                {{ abs.status | absenceEmployeeStatus }}
              </span>
            </div>
          }
        </div>
      </div>
    }

    @if (data.shifts.length > 0) {
      <div>
        <span class="day-type-title">Turnos y horarios</span>
        <div class="flex flex-col gap-1">
          @for (shift of data.shifts; track $index; let isFirst = $first) {
            @if (isFirst) {
              <div class="flex items-center gap-1 py-1">
                <mat-icon
                  class="qaroni-mat-icon-16 material-symbols-outlined text-primary-50">
                  {{ iconType(shift) }}
                </mat-icon>
                <span class="text-xs text-neutral-50" i18n
                  >Tipo de horario</span
                >
                <strong class="text-xs uppercase text-neutral-60" i18n>
                  ({{ shift.type | scheduleType }})
                </strong>
              </div>
            }
            <ng-container
              *ngTemplateOutlet="
                shiftCardTemplate;
                context: {
                  start: shift.startTime,
                  end: shift.endTime,
                  duration: shift.durationMinutes,
                  label: text(shift.name),
                }
              " />
          }
        </div>
      </div>
    }

    @if (data.adminSchedules?.length > 0) {
      <div>
        <span class="day-type-title">Horarios Laborales</span>
        @for (scheduleItem of data.adminSchedules; track $index) {
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1">
              <div class="ml-1 text-[10px] font-bold uppercase text-neutral-60">
                {{ scheduleItem.scheduleName }}
              </div>
              @for (shift of scheduleItem.shifts; track $index) {
                <ng-container
                  *ngTemplateOutlet="
                    shiftCardTemplate;
                    context: {
                      start: shift.startTime.slice(0, 5),
                      end: shift.endTime.slice(0, 5),
                      label: (getDateEnum(shift.weekDay) | dayInfo),
                    }
                  " />
              }
            </div>
          </div>
        }
      </div>
    }

    @if (!hasEvents) {
      <div
        class="flex flex-col items-center justify-center py-4 text-neutral-60">
        <span class="material-icons mb-1 text-3xl">event_busy</span>
        <p class="text-xs">No hay eventos registrados</p>
      </div>
    }
  </div>
</div>

<ng-template
  #shiftCardTemplate
  let-start="start"
  let-end="end"
  let-duration="duration"
  let-label="label">
  <div class="flex items-center rounded-lg bg-primary-90 p-2 text-primary-40">
    <div class="flex h-8 w-8 items-center justify-center rounded-full">
      <mat-icon class="qaroni-mat-icon-16">schedule</mat-icon>
    </div>
    <div class="flex flex-1 flex-col px-3">
      <div class="text-sm font-bold text-slate-700">
        @if (start && end) {
          {{ start }} - {{ end }}
        } @else if (duration) {
          {{ duration | totalMinutesFormat }}
        }
      </div>
      <div class="text-xs font-medium">
        {{ label }}
      </div>
    </div>
  </div>
</ng-template>
